// ============================================================================
// CHINESE REMAINDER - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'chinese-remainder',
  name: 'Chinese Remainder Theorem',
  category: 'Math',
  complexity: {
    time: 'O(N log M)',
    space: 'O(1)'
  },
  description: 'A theorem that provides a way to determine a number that leaves specified remainders when divided by given pairwise coprime integers. Used in modular arithmetic, cryptography, and solving systems of congruences.'
};
